export const lessonsData = [
  {
    id: 1,
    instrument: "Piano",
    description: "Master the keys with personalized piano instruction tailored to your goals and skill level.",
    levels: ["Beginner", "Intermediate"],
    duration: "Flexible timing",
    price: "Contact for rates",
    features: [
      "One-on-one personalized instruction",
      "Classical and contemporary styles",
      "Music theory fundamentals",
      "Performance preparation for all ages"
    ]
  },
  {
    id: 2,
    instrument: "Drums",
    description: "Develop rhythm, coordination, and technique with comprehensive drum lessons in a studio with two complete drumsets.",
    levels: ["Beginner", "Intermediate", "Advanced"],
    duration: "Flexible timing",
    price: "Contact for rates",
    features: [
      "Two drumset studio for active teaching",
      "Rock, jazz, funk, and more styles",
      "Stick technique and rudiments",
      "Reading drum notation and charts"
    ]
  },
  {
    id: 3,
    instrument: "Marching Band & Orchestral Percussion",
    description: "Specialized instruction in marching percussion and orchestral techniques for ensemble performance.",
    levels: ["Beginner", "Intermediate", "Advanced"],
    duration: "Flexible timing",
    price: "Contact for rates",
    features: [
      "Marching snare, tenors, and bass drum",
      "Timpani and mallet percussion",
      "Ensemble playing and sectional work",
      "Audition preparation and technique"
    ]
  }
];

export const testimonialsData = [
  {
    id: 1,
    name: "Sarah Mitchell",
    role: "Piano Student",
    content: "Felix's teaching style is patient, encouraging, and perfectly paced. I've made more progress in months than I thought possible!",
    rating: 5
  },
  {
    id: 2,
    name: "James Peterson",
    role: "Drum Student",
    content: "The dual drumset setup is amazing! Being able to watch and play along with Felix makes learning so much more effective and fun.",
    rating: 5
  },
  {
    id: 3,
    name: "Linda Rodriguez",
    role: "Piano Student",
    content: "Felix's studio is professional and welcoming. He tailors each lesson to my goals and makes learning enjoyable at any age.",
    rating: 5
  },
  {
    id: 4,
    name: "Michael Chen",
    role: "Drum Student",
    content: "From basic beats to complex patterns, Felix breaks everything down clearly. His passion for music is contagious!",
    rating: 5
  }
];

export const galleryData = [
  {
    id: 1,
    type: "image",
    title: "Fun approach to Learning Piano!",
    description: "Personalized instruction in a creative way",
    image: "/images/felix-piano.jpg"
  },
  {
    id: 2,
    type: "image",
    title: "Live Performance",
    description: "Bringing music to life on stage",
    image: "/images/studio-full.jpg"
  },
  {
    id: 3,
    type: "image",
    title: "Complete Home Studio",
    description: "Professional teaching environment with acoustic and electronic drums",
    image: "/images/instructor-photo.jpg"
  },
  {
    id: 4,
    type: "image",
    title: "Roland Electronic Drumkit",
    description: "One of two complete drumsets for active teaching",
    image: "/images/roland-drumkit.jpg"
  }
];

export const aboutData = {
  title: "Meet Felix Munger",
  bio: "I am a passionate music educator based in Nashville offering personalized piano and drum lessons for students of all ages and skill levels! Whether you're a beginner taking your first musical steps or an experienced player looking to refine your technique, I provide tailored instruction in a professional home studio environment equipped with two complete drumsets for comprehensive teaching!",
  experience: "Professional Musician",
  students: "All Ages & Levels",
  specialization: "Piano & Drums",
  studioInfo: "Lessons take place at my fully-equipped home studio, or I will travel to your home."
};